export function getMayorLetterUrl(isPartake: boolean, language: string) {
  if (isPartake) {
    return 'https://docs.google.com/document/d/17lrgDcYYhycSsnHNxSeoySGup3Blz8-eJ4S-IzrC5LU';
  }
  return language.toLowerCase().split(/[-_]/)[0] === 'fr'
    ? 'https://docs.google.com/document/d/1ne0m-GD_QmZhJgn1qkwiu5CTeWz0BPiUpnQTtZZodBk/edit?tab=t.0'
    : 'https://docs.google.com/document/d/1Z5iqVMVECnRyL38y_iQZ2dkAxDyywukw0hgZfGbLei0';
}
